import React from 'react';

import cx from 'classnames';
import { ToggleLayer } from 'react-laag';
import { useDispatch, useSelector } from 'react-redux';

import ItemLink from 'components/Layouts/Admin/Dashboard/Navigation/ItemLink';
import Dropdown from 'components/shared/Dropdown';
import Icon from 'components/shared/Icon';
import Triangle from 'components/shared/Icon/icons/Triangle';
import { useTermsModal } from 'components/shared/Layout/shared/UserMenu/functions';
import * as sharedStyles from 'components/shared/Layout/shared/UserMenu/index.module.css';
import { MODAL_TYPE } from 'constants/modalTypes';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import i18n from 'i18n';
import { setTermsOfServiceModalOpenAction } from 'store/terms_of_use';
import { userSelector } from 'store/user/selectors';
import noop from 'utils/noop';

import styles from './index.module.css';
import { IPageHeaderMenuProps } from './types';

function PageHeaderMenu({
  actions = [],
  userMenuLabelClassName,
  linkClassName,
  alwaysShowDesktop = false,
}: IPageHeaderMenuProps) {
  const dispatch = useDispatch();
  const { firstName, lastName } = useSelector(userSelector);
  const { modal } = useTermsModal();
  const { isTabletOrMobile } = useMediaBreakpoints();

  return (
    <>
      <ToggleLayer
        fixed
        renderLayer={({ isOpen, layerProps, close }) =>
          isOpen && (
            <div
              ref={layerProps.ref}
              className="layer"
              style={{
                ...layerProps.style,

                zIndex: 9999,
              }}
            >
              <Dropdown className={'custom-right-header-dropdown'}>
                {actions.map((action, idx) => (
                  <ItemLink
                    key={idx}
                    isButton
                    isDropdown
                    onClick={() => {
                      action.onClick();
                      close();
                    }}
                    className={cx(styles.userMenuListItem, 'custom-right-header-user-menu-list-item')}
                    linkClassName={cx(
                      styles.userMenuListLabel,
                      linkClassName,
                      'custom-right-header-user-menu-list-label',
                    )}
                    noUnderline
                  >
                    {action.label}
                  </ItemLink>
                ))}
                {/*@ts-ignore*/}
                <div className={cx(sharedStyles.container, alwaysShowDesktop && sharedStyles.desktopOnly)}>
                  <ItemLink
                    isDropdown={!isTabletOrMobile}
                    isButton
                    noMargin
                    // @ts-ignore
                    onClick={() => dispatch(setTermsOfServiceModalOpenAction(MODAL_TYPE.PRIVACY_POLICY)).then(close)}
                    // @ts-ignore
                    linkClassName={cx(sharedStyles.realLink, alwaysShowDesktop && sharedStyles.desktopOnly)}
                    noUnderline
                  >
                    {i18n.t('proposal_content.privacy_policy')}
                  </ItemLink>
                  <ItemLink
                    isDropdown={!isTabletOrMobile}
                    isButton
                    noMargin
                    // @ts-ignore
                    onClick={() => dispatch(setTermsOfServiceModalOpenAction(MODAL_TYPE.TERMS_OF_SERVICE)).then(close)}
                    // @ts-ignore
                    linkClassName={cx(sharedStyles.realLink, alwaysShowDesktop && sharedStyles.desktopOnly)}
                    noUnderline
                  >
                    {i18n.t('proposal_content.terms_conditions')}
                  </ItemLink>
                </div>
              </Dropdown>
            </div>
          )
        }
        placement={{
          anchor: 'BOTTOM_LEFT',
          autoAdjust: true,
          triggerOffset: 10,
        }}
        closeOnOutsideClick
      >
        {({ triggerRef, toggle }) => {
          return (
            <button
              type="button"
              className={cx(styles.userMenu, 'custom-right-header-user-menu')}
              ref={triggerRef}
              onClick={actions.length > 0 ? toggle : noop}
            >
              {actions.length > 0 && (
                <Icon
                  component={Triangle}
                  width="0.4rem"
                  height="0.8rem"
                  className={cx(styles.userMenuArrowIcon, 'custom-right-header-arrow-icon')}
                />
              )}
              <div
                className={cx(
                  styles.userMenuLabel,
                  userMenuLabelClassName,
                  styles.defaultUserMenuLabel,
                  'custom-right-header-username',
                )}
              >
                <div className={styles.userName}>{firstName || lastName || i18n.t('proposal_content.hello_guest')}</div>
              </div>
            </button>
          );
        }}
      </ToggleLayer>
      {modal}
    </>
  );
}

export default PageHeaderMenu;
